<template>
  <dl class="browse_slat_ctg">
    <template v-for="{ id, name } in slat_ctg_by_product">
      <dt class="ctg__title" :class="{bordered: id.startsWith('_'), [id]: true}" :key="name" @click="toggle($event)">
        <div class="title_container" :class="id">
          <img v-if='isSudare(id)' :src="require(`../../assets/img/parts/category/${id}.svg`)" width="84" height="10">
          <span v-else-if="isSeriesToki(id)" class="toki">
            {{  name.slice(5) }}
          </span>
          <span v-else>{{ isLargeSudareish(id) ? 'スダレ' : name }}</span>
          <ctg-arrow class="title__arrow" :class="{black: id.startsWith('_')}"/>
        </div>
      </dt>
      <dd class="ctg__content" :key="id">
        <list-slat-items :slats="getSlatsByCtgName(name)" />
      </dd>
    </template>
  </dl>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import ListSlatItems from './parts/ListSlatItems.vue'
import CtgArrow from './parts/CtgArrow.vue'

const getTargetToScroll = (selectedCtg, secondary, currentCtg) => {
  const key = secondary ? 'id2' : 'id'
  const selectId = selectedCtg[key]
  if (selectId) {
    const idx = currentCtg.findIndex(({id}) => id === selectId)
    return idx > -1 && document.querySelectorAll(".ctg__title")[idx]
  }
}

export default {
  name: "BrowseSlatByCtg",
  components: { ListSlatItems, CtgArrow },
  mounted () {
    const targetToScroll = getTargetToScroll(
      this.slat_select_ctg, this.secondary_target, this.slat_ctg_by_product
    )
    if (targetToScroll) {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          this.toggleOpenThenScrollTo(targetToScroll)
        })
      })
    }
  },
  updated () {
    const targetToScroll = getTargetToScroll(
      this.slat_select_ctg, this.secondary_target, this.slat_ctg_by_product
    )
    if (targetToScroll) {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          this.toggleOpenThenScrollTo(targetToScroll, true)
        })
      })
    }
  },
  computed: {
    ...mapState("simulator", ["slat_list"]),
    ...mapGetters('simulator', ['slat_select_ctg', 'slat_ctg_by_product', 'secondary_target', 'editing_productType']),
  },
  methods: {
    ...mapMutations(['setModal']),
    getSlatsByCtgName (ctgName) {
      return this.slat_list
        .filter(({category}) => category === ctgName);
        // .filter(({id}) => process.env.NODE_ENV === 'development' || id !== 'PS-2201' );
    },
    isSudare (id) {
      return id === 'sudare'
    },
    isSeriesToki (id) {
      return id.startsWith('toki-')
    },
    isLargeSudareish (id) {
      return this.editing_productType === 'RS-Large' && id === 'sudare-ish'
    },
     toggleOpenThenScrollTo (el, add) {
      const onOpenEnd = () => {
        if (this.slat_ctg_by_product.length < 3) return
        // el.removeEventListener('transitionend', onOpenEnd)
        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
      }
      el.addEventListener('transitionend', onOpenEnd, { once: true })
      el.classList[add ? 'add' : 'toggle']('opened')
    },
    toggle (ev) {
      const { currentTarget } = ev
      this.toggleOpenThenScrollTo(currentTarget)
    }
  }
}
</script>

<style lang="scss">
.browse_slat_ctg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0;
  min-height: 100%;
  font-size: clamp(10px, 1.5vw, 18px);
  .ctg__title {
    box-sizing: border-box;
    position: relative;
    margin-bottom: calc(8 / 295 * 100%);
    border-radius: 50px;
    overflow: hidden;
    transition: margin 0.4s;
    &._duole, &._lumie, &._airle {
      display: none;
    }
    cursor: pointer;
    &::before {
      display: block;
      content: "";
      padding-top: calc(16 / 295 * 100%);
    }
    &.bordered {
      border: 2px solid #000;
      scroll-margin: 100px;
      .title_container {
        top: -1px;
        left: -1px;
      }
    }
    .title_container {
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      padding: 0 calc(16 / 295 * 100%);
      width: 100%;
      height: 100%;
      color: white;
      background-color: #ddd;
      > img {
        width: calc(84 / 263 * 100%);
        height: auto;
      }
      &::before {
        display: block;
        margin-right: calc(10 / 295 * 100%);
        background: {
          size: cover;
          position: center;
          repeat: no-repeat;
        };
      }
      .title__arrow {
        position: absolute;
        right: calc(16 / 295 * 100%);
        display: block;
        width: calc(7 / 263 * 100%);
        height: calc(15 / 9 * 7 / 16 * 100%);
        transition: transform 0.2s;
      }
      &[class*=" _"] {
        color: black;
        background-color: #fff;
      }
      &.sohostyle {
        background-color: #686669;
        &::before {
          content: '';
          margin-top: calc(2 / (295 - 32) * 100%);
          width: calc(54 / (295 - 32) * 100%);
          height: calc(10 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/sohostyle_head.svg);
        }
      }
      &.industrial {
        background-color: #1d295b;
        &::before {
          content: '';
          width: calc(65 / (295 - 32) * 100%);
          height: calc(7 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/industrial_head.svg);
        }
      }
      &.nordic {
        background-color: #c9ba98;
        &::before {
          content: '';
          width: calc(44 / (295 - 32) * 100%);
          height: calc(9 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/nordic_head.svg);
        }
      }
      &.botanical {
        background-color: #10522d;
        &::before {
          content: '';
          width: calc(65 / (295 - 32) * 100%);
          height: calc(8 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/botanical_head.svg);
        }
      }
      &.wood {
        background-color: #5d3600;
      }
      &.muji {
        color: black;
        background-color: #D4C9AD;
        & svg path{
          fill: #000;
        }
      }
      &.shakou {
        color: #fff;
        background-color: #4E6388;
      }
      &.lace {
        color: black;
        background-color: #F2F2F3;
        & svg path{
          fill: #000;
        }
      }
      &.phyto_calm{
        background:
          linear-gradient(
            120deg, #9EB2BD 0%, #A8A4AF 100%
          );
        color: black;
        background-color: #F2F2F3;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(37 / (185 - 32) * 100%);
          height: calc(6 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/phyto_calm.svg);
        }
    }
    &.fun_slow{
      background:
        linear-gradient(
          120deg, #D2DE7D 0%, #BDA182 100%
        );
        color: black;
        background-color: #F2F2F3;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(34 / (185 - 32) * 100%);
          height: calc(7 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/fun_slow.svg);
        }
    }
      &.toki-washi {
        background: linear-gradient(
        90deg, #ECE4D7 0%, #ECE4D7 14%, #E8D497 14%, #E8D497 100%
        );
      }
      &.toki-sudare {
        background: linear-gradient(
        90deg, #ECE4D7 0%, #ECE4D7 14%, #8B7F71 14%, #8B7F71 100%
        );
      }
      &.toki-washi, &.toki-sudare {
        .toki {
          flex: 1 1 auto;
          display: inline grid;
          grid-template-columns: 8% 1fr;
          color: #333;
          column-gap: 1.5em;
          &::before {
            content: 'トキ';
            color: #333;
            margin-inline-start: -1em;
            justify-self: center;
          }
        }
      }
      &.toki-sudare .toki {
        color: #fff;
      }
      &.wa- {
        background-color: #6A6F27;
      }
      &.sudare {
        background-color: #86755E;
      }
      &.sudare-ish {
        background-color: #86755E;
      }
      &.washi {
        background-color: #e67e53;
      }
      &._eco, &._fireproof {
        letter-spacing: 0.5em;
      }
      &.phyto{
        background-color: #9EB2BD;
        color: #000000;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(32 / (315 - 32) * 100%);
          height: calc(7 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/phyto.svg);
        }
      }
      &.calm{
        background-color: #A9A5B0;
        color: #000000;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(32 / (295 - 32) * 100%);
          height: calc(6 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/calm.svg);
        }
      }
      &.fun{
        background-color: #D2DE7D;
        color: #000000;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(26 / (315 - 32) * 100%);
          height: calc(9 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/fun.svg);
        }
      }
      &.slow{
        background-color: #BDA182;
        color: #000000;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(30 / (305 - 32) * 100%);
          height: calc(7 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/slow.svg);
        }
      }
      &.feel_clear{
        background-color: #D1EBF9;
        color: #000000;
        & svg path{
          fill: #000;
        }
        &::before {
          content: '';
          width: calc(46 / (275 - 32) * 100%);
          height: calc(6 / 16 * 100%);
          background-image: url(../../assets/img/parts/category/feel_clear.svg);
        }
      }
      &.wood{
      background-color: #86755E;
      color: #000;
      & svg path{
          fill: #000;
        }
    }
    }
  }
  .ctg__content {
    margin: 0;
    height: 0;
    overflow: hidden;
    transition: height 0.4s;
  }
  .ctg__title.opened {
    margin-bottom: 0;
    .title_container {
      .title__arrow {
        transform: scale(1, -1);
      }
    }
    + .ctg__content {
        height: auto;
        overflow: hidden;
        // overflow-y: auto;
    }
  }
}
</style>